<template>
    <div :id="controlId" class="lni-o-grid--wrap lni-u-items-end">
        <x-input-text
            ref="firstName"
            :data-control-id="controlId + '_firstName'"
            :data-parent-id="controlId"
            :data-parent-short-name="shortName"
            :is-nested="true"
            data-short-name = "First Name"
            data-label-text="First Name"
            :data-required="true"
            v-on:dataChanged="onDataChanged"
            v-on:errorChanged="onFirstNameErrorChanged"
        >
            <x-error v-if="errorText('firstName')" :data-local-text="errorText('firstName')" />
        </x-input-text>
        <x-input-text
            ref="lastName"
            class="lni-u-pt0"
            :data-control-id="controlId + '_lastName'"
            :data-parent-id="controlId"
            :data-parent-short-name="shortName"
            :is-nested="true"
            data-short-name = "Last Name"
            data-label-text="Last Name"
            :data-required="true"
            v-on:dataChanged="onDataChanged"
            v-on:errorChanged="onLastNameErrorChanged"
        >
            <x-error v-if="errorText('lastName')" :data-local-text="errorText('lastName')" />
        </x-input-text>
    </div>
</template>

<script>
import framework from '../../framework';

export default {
    name: 'x-input-name',
    mixins: [
        framework.mixins.abstractAggregateInput,
    ],
    mounted() {
        this.initialize();
    },
    computed: {
        componentValue: {
            get() {
                return {
                    firstName: this.$refs.firstName.value,
                    lastName: this.$refs.lastName.value,
                };
            },
            set(newValue) {
                this.$refs.firstName.value = newValue.firstName;
                this.$refs.lastName.value = newValue.lastName;
            },
        },
    },
    methods: {
        /**
         * Adds the error from the child component to the errors of this component
         * @param {*} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onFirstNameErrorChanged(errorMessage) {
            this.onErrorChanged('firstName', errorMessage);
        },
        /**
         * Adds the error from the child component to the errors of this component
         * @param {*} errorMessage The error message that the child component is passing.
         * @returns {void}
         */
        onLastNameErrorChanged(errorMessage) {
            this.onErrorChanged('lastName', errorMessage);
        },
    },
};

</script>



// WEBPACK FOOTER //
// source/components/x-input-name/x-input-name.vue